var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedicationnote = function SvgMedicationnote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "#fff",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F4970",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M45.667 32.333v13.334M39 37.333v8.334m-6.667-3.334v3.334M29 52.333h20A3.333 3.333 0 0 0 52.333 49V29A3.333 3.333 0 0 0 49 25.667H29A3.333 3.333 0 0 0 25.667 29v20A3.333 3.333 0 0 0 29 52.333"
  })));
};
export default SvgMedicationnote;